import { render, staticRenderFns } from "./Liquidaciones.vue?vue&type=template&id=62746d32"
import script from "./Liquidaciones.vue?vue&type=script&lang=js"
export * from "./Liquidaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports